<template>
    <v-container class="pa-2" fluid grid-list-sm >   
        <v-layout row wrap>
            <v-flex xs6 offset-3> 
                <v-card>
                    <v-layout row justify-end>
                        <v-btn color=primary @click="startCourse()">Start course</v-btn>
                    </v-layout>
                <v-card-title>                    
                    {{info.title}}
                </v-card-title>
                <v-card-text>
                    <p style="font-weight: bold">{{info.description}}</p>
                   
                    <div v-html="info.description_detail"></div>
                
                   <hr>
                   <p></p>
                    <h2 v-if="contentPopulated" @click="contentPopulated = !contentPopulated"> Content </h2>
                    <h2 v-if="!contentPopulated" @click="contentPopulated = !contentPopulated"> Show content </h2>
                    <p></p>
                    <ul v-if="contentPopulated" >
                        <li v-for="(chapter) in info.chapterlist" v-bind:key="chapter.chapter_id" @click="populated = chapter.chapter_id;">
                            <p style="font-weight: bold">{{chapter.name}} ({{chapter.lessons.length}} lessons) </p>
                            <ul v-if="populated == chapter.chapter_id"> 
                                <li v-for="(lesson) in chapter.lessons" v-bind:key="lesson.lesson_id" >
                                {{lesson.lesson}} ({{lesson.tasks}} tasks / {{lesson.programs}} programs)
                                </li>
                            </ul>
                            <p></p>
                        </li>
                    </ul>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {
            info : [],
            populated: 0,
            contentPopulated: false
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    
            this.$store.commit('setBcChange',true)

            // get category list
            axios.get('/course-preview/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.info = res.data 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        startCourse() {            
            this.$store.commit('setFeedback', null)    
            // get category list
            axios.post('/write-user-course/' + this.$route.params.id, null, this.$store.getters.getAxiosConfig)
                .then(() => {
                    // open course
                    this.$router.push({name:'course_content', params: {id: this.$route.params.id}})   
                    ///////////////////////////////////////////////////////////////////////
                })
                .catch(error => {
                    // console.log(error.message)
                    this.$store.commit('setFeedback', error)
                })
        },        
    }
}
</script>


<style>

</style>
